import { Component, OnInit } from '@angular/core';
import { Crisp } from 'crisp-sdk-web';

@Component({
  selector: 'app-cancelled',
  templateUrl: './cancelled.component.html',
  styleUrls: ['./cancelled.component.scss']
})
export class CancelledComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  openChat() {
    Crisp.chat.open();
  }
}
